import Modal from './classes/modal.class';
const app = new Vue({
    el: '#app',
    props: ['session_id'],
    data: {
        loginPending: false,
        host: null,
        appToken: null,
        userToken: null,
        isModalShow: false, // Questa qui gestice solo la modal del login
        modals: [], // Questa property comanda le modal programmatiche
        excluded_list: [],
        user: {
            nome: null,
            cognome: null,
            email: null,
            id: null,
            telefono: null,
            preferiti: null
        },
        mobilecat: null,
        annunciProp: {
            rows: [],
            total: '0',
            type: ''
        },
        mapselected: false,
        mapLoaded: false,
        redirectAfterLogin:null,
        backofficeUrl: process.env.MIX_BACKOFFICE_URL,
        s3FrontStaticAssetsUrl: process.env.MIX_ASSETS_URL_S3
    },
    methods: {
        setJson(apptoken) {
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + apptoken;
            this.appToken = apptoken
        },
        showMap() {
            $('html, body').css({
                overflow: 'hidden',
                height: '100%'
            });
            $('.main-map-comp').show();
        },
        setUserHeader(usertoken) {
            if(usertoken) {
                window.axios.defaults.headers.common['UserAuthorization'] = 'Bearer ' + usertoken;
                this.userToken = usertoken;
            }
        },
        isLoading(classcss) {
            Vue.toasted.show(
                '   Attendere caricamento dati...  ', {
                duration: null,
                position: 'top-center',
                theme: "toasted-primary",
                icon : {
                    name : 'fa fa-hourglass'
                },
                className: classcss
            });
        },
        stopLoading() {
            Vue.toasted.clear();
        },
        alertHttp(classcss = 'toast-alert', text) {
            Vue.toasted.show(
                '  ' + text + '  ', {
                duration: 5000,
                position: 'top-center',
                theme: "toasted-primary",
                icon : {
                    name : 'fa fa-exclamation-triangle'
                },
                className: classcss
            });
        },
        info(classcss = '', text) {
            Vue.toasted.show(
                text, {
                duration: 5000,
                position: 'top-center',
                theme: "toasted-primary",
                icon : {
                    name : 'fa fa-info'
                },
                className: classcss
            });
        },
        setHost(host) {
            this.host = host;
        },
        setUser(user) {
            if(user) {
                Vue.set(this.user, 'id', user.id)
                Vue.set(this.user, 'nome', user.nome)
                Vue.set(this.user, 'cognome', user.cognome)
                Vue.set(this.user, 'email', user.email)
                Vue.set(this.user, 'telefono', user.telefono)
                this.setPreferitiList(user.preferiti)
            } else {
                Vue.set(this.user, 'id', null)
                Vue.set(this.user, 'nome', null)
                Vue.set(this.user, 'cognome', null)
                Vue.set(this.user, 'email', null)
                Vue.set(this.user, 'telefono', null)
                this.setPreferitiList()
            }
        },
        setExcluded(excluded_list = []) {
            this.excluded_list= excluded_list
        },
        setRedirectAfterLogin(redirect){
            this.redirectAfterLogin = redirect;
        },
        salvaUserInSessione (user, pSessionID) {
            const paramSession = {
                token: this.userToken,
                user: user,
            }
            // Eseguo la chiamata al "server" del front per salvare il token in sessione
            window.axios.post('/api/session', paramSession)
            .then(res => {
                if(this.redirectAfterLogin){
                    let redirectTo = this.redirectAfterLogin;
                    this.setRedirectAfterLogin(null);
                    window.location.href = redirectTo;
                }
                else{
                    this.loginPending = false;
                    this.closeLogin();
                }
            });
        },
        doGetProfiloUtente(access_token, pSessionID) {
            // Chiamo i dati dell'utente dal core
            window.axios.get(window.base_url + 'people/profile')
            .then(resuser => {
                // Mi storo l'utente in una property nel componente padre così da accederci da ovunque
                this.$root.setUser(resuser.data.data);
                this.salvaUserInSessione(resuser.data.data, pSessionID)
            });
        },
        setPreferitiList (preferiti = null) {
            Vue.set(this.user, 'preferiti', preferiti)
        },
        showLogin(redirectTo = null) {
            $('#login').modal('show');
            if (redirectTo){
                this.setRedirectAfterLogin(redirectTo);
            }
            this.isModalShow = true;
        },
        closeLogin() {
            this.setRedirectAfterLogin(null);
            $('#login').modal('hide');
            this.isModalShow = false;
        },
        pushModal(modal) {
            this.modals.push(modal);
            Vue.nextTick(() => {
                this.$modal.show(modal.name);
            });
        },
        showModalTelefonoImmobile(data) {
            const modal = new Modal({
                name: 'modal-telefono-immobile-' + data.immobile_id,
                class: 'small-modal',
                component: 'modal-telefono-immobile',
                closeButton: false,
                padding: true,
                callback: () => { this.$modal.hide('modal-telefono-immobile-' + data.immobile_id); },
                bind: {
                    data: data
                }
            });
            this.pushModal(modal);
        }
    },
    computed: {
        isLoggedIn () {
            return this.$root.user.id !== null
        },
    }
});
